import React from 'react';
import Button from '../../components/Button/Button';
import StartWorkingTogetherImage from '../../assets/svg/start-working-together.svg';
import StartWorkingTogetherImageMobile from '../../assets/svg/start-working-together-mobile.svg';

const StartWorkingTogether = ({ additionalClasses, dataEventLocation }) => (
    <section
        className={[
            'start-working-together-section py-5',
            additionalClasses,
        ].join(' ')}
    >
        <div className="container-fluid">
            <div className="row">
                <div className="col-12 text-center">
                    <h2 className="start-working-together-section__header py-3">
                        Start working. Together.
                    </h2>
                    <h3 className="start-working-together-section__paragraph py-3 py-md-4">
                        Reach common flow which just gets things done.
                    </h3>
                    <img
                        src={StartWorkingTogetherImage}
                        width="50%"
                        height="50%"
                        className="start-working-together-section__image py-5 d-none d-md-block"
                        alt=""
                    />
                    <img
                        src={StartWorkingTogetherImageMobile}
                        width="50%"
                        height="50%"
                        className="start-working-together-section__image py-4 py-md-5 d-block d-md-none"
                        alt=""
                    />
                    <Button
                        click={() =>
                            window.open(
                                `${process.env.GATSBY_FLOTIQ_DASHBOARD_URL}/register?plan=1ef44daa-fdc3-6790-960e-cb20a0848bfa`,
                                '_self'
                            )
                        }
                        additionalClasses={['btn-with-chevron my-4']}
                        dataEventLocation={dataEventLocation}
                    >
                        Start for free
                    </Button>
                </div>
            </div>
        </div>
    </section>
);

export default StartWorkingTogether;
